import type { HTMLAttributes, ReactNode } from 'react'

/** Props for {@link Lang}. */
export interface LangProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * BCP 47 language code: `hi` (Hindi in Devanagari), `hi-Latn` (romanised Hindi/Hinglish),
   * `id`, `es`, `pt-BR`, `sw`, ... Content entries carry these codes (`lang` / `langCode`).
   */
  code: string
  children: ReactNode
}

/**
 * Marks a run of non-English text with its language, so screen readers switch voice and
 * browsers pick the right hyphenation and quotes. Devanagari (`hi`, `mr`, `ne`, `sa`) sets
 * in Anek Devanagari automatically (global CSS); romanised `hi-Latn` keeps the
 * surrounding font. Decorative, repeated text (like `hero.speakWords`) also needs `aria-hidden`.
 *
 * @example
 * <Lang code="hi">{manifesto.karta.deva}</Lang>
 * <Lang code="hi-Latn">{cta.kicker}</Lang>
 */
export function Lang({ code, children, ...rest }: LangProps) {
  return (
    <span lang={code} {...rest}>
      {children}
    </span>
  )
}
